import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { CategoryService } from '../category.service';
import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';
import { SessionService } from 'app/core/services/session.service';

@Component({
  selector: 'itpx-category-edit',
  templateUrl: './category-edit.component.html',
  styleUrls: ['./category-edit.component.css']
})
export class CategoryEditComponent implements OnInit {

    private details: any;
    private cancelRoute: string = '/agora/product-data/categories';
    private fields: any[];
    private id: string;

    constructor(
            private service: CategoryService,
            private configService: ConfigService,
            private notificationService: NotificationService,
            private router: Router,
            private route: ActivatedRoute,
            private sessionService: SessionService
    ) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.id = params['id'];
            let userDetails = this.sessionService.getUserDetails();
            this.fields = this.service.getFields();
            if (userDetails && userDetails['groups'] &&
            (userDetails['groups'].indexOf('catalog-manager') >= 0 ||
            userDetails['groups'].indexOf('administrator') >= 0)) {
                this.fields.push({
                    key: 'online',
                    label: 'Online',
                    type: 'radio',
                    options: [
                        {key: true,  value: 'Yes'},
                        {key: false,  value: 'No'}
                    ],
                    required: false,
                    default: false
                })
            }
            this.service.getCategoryDetails(this.id)
                .subscribe(
                    body => {
                        this.setDetails(<any>body['data']);
                    }
                );
        });
    }

    private setDetails(details: any) {
        details.categoryFamily = details.categoryFamily ? details.categoryFamily.map(_ => { return _.id }) : [];
        details.topics = details.topics ? details.topics.map(_ => { return _.id }) : [];
        details.customTopics = details.customTopics ? details.customTopics.map(_ => { return _.id }) : [];
        this.details = details;
    }

    private onSaveFinished(category: any) {
        this.service.edit(this.service.formatData(category))
            .subscribe(
                body => {
                    const response = body['data'];
                    this.notificationService.success('Successfully updated the category', 'Success');
                    this.router.navigate(['/agora/product-data/categories/:id/details', { id: this.id }]);
                }
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/categories/edit/category-edit.component.ts